"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ListingContext_1 = require("./ListingContext");
var defaultListingContextValues = {
    filtering: {
        selection: {},
        setAllFilters: function () { },
        setFilter: function () { }
    },
    paging: {
        pageNumber: 0,
        pageSize: Number.MAX_SAFE_INTEGER,
        setCurrentPage: function () { },
    },
    sorting: {
        sortOrder: undefined,
        setSortOrder: function () { }
    }
};
function useListingContext() {
    var listingContextValues = React.useContext(ListingContext_1.ListingContext);
    if (!listingContextValues.filtering && !listingContextValues.paging && !listingContextValues.sorting) {
        var msg = "useListingContext being used outside of ListingContext";
        console.error(msg, "ListingContext", new Error(msg));
        return defaultListingContextValues;
    }
    return listingContextValues;
}
exports.default = useListingContext;
//# sourceMappingURL=useListingContext.js.map